//react
import React, { useEffect, useState } from "react";

//css
import "./Prensa.css";

//hooks
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";

//react-router-dom
import { useNavigate, useParams } from "react-router-dom";

//utils
import TEXT from "../../utils/text/prensa.json";

//antd
import { Divider } from "antd";

//Components
import BIDButton from "../../components/reusable/BIDButton/BIDButton";
import PageTitleSection from "../../components/reusable/PageTitleSection/PageTitleSection";

//import { PDFGenerator } from "./PDFGenerator";

//pdf
import { jsPDF } from "jspdf";
//import { PDFDownloadLink, Text, View, StyleSheet, Image } from "@react-pdf/renderer"

//text
import Migracion from "../../components/Prensa/Migracion/Migracion";
import Retorno from "../../components/Prensa/Retorno/Retorno";
import miscTEXT from "../../utils/text/misc.json";

const tabs = [
  {
    key: "mig", //Migracion
    title: "migracion",
  },
  {
    key: "ret",
    title: "retorno",
  },
];

export const COUNTRY_OPTIONS = [
  {
    name: "LAC",
    url: "",
    country: "region",
    country_text: " América Latina y el Caribe",
    country_text_en: "Latin America and the Caribbean",
    code: "LAC",
  },
  {
    country: "argentina",
    country_text: "Argentina",
    country_text_en: "Argentina",
    code: "Argentina",
  },
  {
    country: "belice",
    country_text: "Belice",
    country_text_en: "Belize",
    code: "Belize",
  },
  {
    country: "bolivia",
    country_text: "Bolivia",
    country_text_en: "Bolivia",
    code: "Bolivia",
  },
  {
    country: "brasil",
    country_text: "Brasil",
    country_text_en: "Brazil",
    code: "Brazil",
  },
  /* {
    country: "caribe",
    country_text: "Caribe",
    country_text_en: "Caribbean",
    code: "Caribe",
  }, */
  {
    country: "chile",
    country_text: "Chile",
    country_text_en: "Chile",
    code: "Chile",
  },
  {
    country: "colombia",
    country_text: "Colombia",
    country_text_en: "Colombia",
    code: "Colombia",
  },
  {
    country: "costa_rica",
    country_text: "Costa Rica",
    country_text_en: "Costa Rica",
    code: "Costa Rica",
  },
  {
    country: "ecuador",
    country_text: "Ecuador",
    country_text_en: "Ecuador",
    code: "Ecuador",
  },
  {
    country: "el_salvador",
    country_text: "El Salvador",
    country_text_en: "El Salvador",
    code: "El Salvador",
  },
  {
    country: "guatemala",
    country_text: "Guatemala",
    country_text_en: "Guatemala",
    code: "Guatemala",
  },
  {
    country: "honduras",
    country_text: "Honduras",
    country_text_en: "Honduras",
    code: "Honduras",
  },
  {
    country: "mexico",
    country_text: "México",
    country_text_en: "Mexico",
    code: "Mexico",
  },
  {
    country: "nicaragua",
    country_text: "Nicaragua",
    country_text_en: "Nicaragua",
    code: "Nicaragua",
  },
  {
    country: "panama",
    country_text: "Panamá",
    country_text_en: "Panama",
    code: "Panama",
  },
  {
    country: "paraguay",
    country_text: "Paraguay",
    country_text_en: "Paraguay",
    code: "Paraguay",
  },
  {
    country: "peru",
    country_text: "Perú",
    country_text_en: "Peru",
    code: "Peru",
  },
  {
    country: "dominican_republic",
    country_text: "República Dominicana",
    country_text_en: "Dominican Republic",
    code: "Dominican Republic",
  },
  {
    country: "trinidadytobago",
    country_text: "Trinidad y Tobago",
    country_text_en: "Trinidad and Tobago",
    code: "Trinidad and Tobago",
  },
  {
    country: "uruguay",
    country_text: "Uruguay",
    country_text_en: "Uruguay",
    code: "Uruguay",
  },
  {
    country: "venezuela",
    country_text: "Venezuela",
    country_text_en: "Venezuela",
    code: "Venezuela",
  },
];

export const COUNTRY_OPTIONS_RET = [
  {
    name: "NAC",
    url: "",
    country: "region",
    country_text: "Norte de Centroamérica",
    country_text_en: "Northern Central America",
    code: "NAC",
  },
  {
    country: "el_salvador",
    country_text: "El Salvador",
    country_text_en: "El Salvador",
    code: "El Salvador",
  },
    {
    country: "mexico",
    country_text: "Mexico",
    country_text_en: "Mexico",
    code: "Mexico",
  },
  {
    country: "guatemala",
    country_text: "Guatemala",
    country_text_en: "Guatemala",
    code: "Guatemala",
  },
  {
    country: "honduras",
    country_text: "Honduras",
    country_text_en: "Honduras",
    code: "Honduras",
  },
  {
    country: "NCA+Mexico",
    country_text: "NCA+Mexico",
    country_text_en: "NCA+Mexico",
    code: "all",
  },
];

export default function Prensa() {
  //language
  const { language, languagePath } = useCurrentLanguage();

  //params
  let navigate = useNavigate();
  const { country } = useParams();

  //useState - country
  const [selectedCountry, setSelectedCountry] = useState(country);
  const [countryName, setCountryName] = useState("LAC");
  const [countries, setCountries] = useState([]);

  //useState - countries ret
  // const [selectedCountryRet, setSelectedCountryRet] = useState(country);
  // const [countryNameRet, setCountryNameRet] = useState("NAC");
  const [countriesRet, setCountriesRet] = useState([]);

  //useState - tabs
  const [isMediosSelected, setIsMediosSelected] = useState(false);
  const [isSentimentSelected, setIsSentimentSelected] = useState(false);
  const [isDiscussionSelected, setIsDiscussionSelected] = useState(false);
  const isGenderSelected = false;
  const [isComparisonSelected, setIsComparisonSelected] = useState(false);

  //useState - img media
  const [mediaImg1, setMediaImg1] = useState("");
  const [mediaImg2, setMediaImg2] = useState("");

  //useState - img discussion
  const [discussionImg, setDiscussionImg] = useState("");
  const [discussionImg2, setDiscussionImg2] = useState("");
  const [discussionImg3, setDiscussionImg3] = useState("");
  const [discussionImg4, setDiscussionImg4] = useState("");
  const [discussionImg5, setDiscussionImg5] = useState("");
  const [discussionImg6, setDiscussionImg6] = useState("");

  //useState - img sentiment
  const [sentimentImg, setSentimentImg] = useState("");
  const [sentimentImg2, setSentimentImg2] = useState("");
  const [sentimentImg3, setSentimentImg3] = useState("");
  const [sentimentImg4, setSentimentImg4] = useState("");

  //useState - img comparison
  const [comparisonImg, setComparisonImg] = useState("");

  //usestate -tabs
  const [currentTab, setCurrentTab] = useState("mig");

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: "pageview",
    });
    const hash = window.location.hash;

    const queryString = hash.substring(hash.indexOf("?") + 1);

    const queryParams = new URLSearchParams(queryString);

    const prensaParams = queryParams.get("prensa");
    if (!prensaParams) {
      setCurrentTab("mig");
    } else {
      setCurrentTab(prensaParams);
    }
  }, []);

  //useEffect - change url last key to NAC instead of LAC on tab change
  /* useEffect(() => {
    if(currentTab === "ret") {
      navigate(languagePath + "/prensa/NAC", { replace: false });
    }
    else {
      navigate(languagePath + "/prensa/LAC", { replace: false });
    }
  }, [currentTab, languagePath, navigate]); */

  const handleClick = (key) => setCurrentTab(key);

  //useEffect - country
  useEffect(() => {
    setSelectedCountry(country);
    let tempCountry = COUNTRY_OPTIONS.find((co) => country === co.code);
    setCountryName(
      language === "en" ? tempCountry.country_text_en : tempCountry.country_text
    );
    //setCountries(COUNTRY_OPTIONS.map((co) => { code: co.code, label: language === "en" ? co.country_text_en : co.country_text }));
    let tempCountries = COUNTRY_OPTIONS.map((co) => {
      return {
        code: co.code,
        label: language === "en" ? co.country_text_en : co.country_text,
      };
    });
    console.log(tempCountries);
    setCountries(tempCountries);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country]);

  //useEffect - country ret
  useEffect(() => {
    let tempCountries = COUNTRY_OPTIONS_RET.map((co) => {
      return {
        code: co.code,
        label: language === "en" ? co.country_text_en : co.country_text,
      };
    });
    console.log(tempCountries);
    setCountriesRet(tempCountries);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleSelectChange(newValue) {
    navigate(languagePath + "/prensa/" + newValue, { replace: false });
    setSelectedCountry(newValue);
  }

  function mediosOnClick() {
    setIsMediosSelected(!isMediosSelected);
  }

  function sentimentOnClick() {
    setIsSentimentSelected(!isSentimentSelected);
  }

  // function genderOnClick() {
  //   setIsGenderSelected(!isGenderSelected);
  // }

  function discussionOnClick() {
    setIsDiscussionSelected(!isDiscussionSelected);
  }

  function comparisonOnClick() {
    setIsComparisonSelected(!isComparisonSelected);
  }

  function showSection(section) {
    if (
      !isMediosSelected &&
      !isSentimentSelected &&
      !isDiscussionSelected &&
      !isComparisonSelected
    )
      return true;

    switch (section) {
      case "medios":
        return isMediosSelected;
      case "sentiment":
        return isSentimentSelected;
      case "topics":
        return isDiscussionSelected;
      case "gender":
        return isGenderSelected;
      case "amplification":
        return isComparisonSelected;
      default:
        return true;
    }
  }

  //handle download pdf report
  const handleDownloadReport = () => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "in",
      format: [8.5, 11],
    });
    console.log("Downloading report...");

    const titleStyle = {
      align: "center",
      color: "#305ea9", // Custom color
    };

    doc.setPage(1);
    doc.setFontSize(22); // Large font for the title
    doc.setTextColor(titleStyle.color);
    doc.text("Reporte Prensa", 4.25, 3, { align: titleStyle.align }); // Centered title
    doc.setFontSize(16); // Smaller font for the subtitle
    doc.text(`País: ${selectedCountry}`, 4.25, 4, { align: titleStyle.align }); // Include the selectedCountry variable
    doc.setFontSize(12); // Reset font size for the date
    doc.text(new Date().toLocaleDateString(), 4.25, 5, {
      align: titleStyle.align,
    }); // Print the current date

    // Add logo image
    // Note: You will need to have the image data for the logo as base64 or a URL
    /* const logo = '/public/BID-logo.png';
    doc.addImage(logo, 'PNG', 3.75, 1, 1, 1); */

    doc.addPage();
    doc.setPage(2);
    doc.text(TEXT["volume"][language], 4.25, 0.5, { align: titleStyle.align });
    doc.addImage(mediaImg1, "PNG", 0.5, 1, 7.5, 4);
    doc.addImage(mediaImg2, "PNG", 0.5, 5.5, 7.5, 4);
    doc.addPage();
    doc.setPage(3);
    doc.text(TEXT["topics"][language], 4.25, 0.5, { align: titleStyle.align });
    doc.addImage(discussionImg, "PNG", 0.5, 1, 7.5, 4);
    doc.addImage(discussionImg2, "PNG", 0.5, 5.5, 7.5, 4);
    doc.addPage();
    doc.setPage(4);
    doc.addImage(discussionImg3, "PNG", 0.5, 1, 7.5, 4);
    doc.addImage(discussionImg4, "PNG", 0.5, 5.5, 7.5, 4);
    let currentPage = 4;
    if (discussionImg5 === "" || discussionImg6 === "") {
      doc.addPage();
      doc.setPage(5);
      doc.addImage(discussionImg5, "PNG", 0.5, 1, 7.5, 4);
      doc.addImage(discussionImg6, "PNG", 0.5, 5.5, 7.5, 4);
      currentPage = 5;
    }
    doc.addPage();
    doc.setPage(currentPage + 1);
    doc.text(TEXT["sentiment"][language], 4.25, 0.5, {
      align: titleStyle.align,
    });
    doc.addImage(sentimentImg, "PNG", 0.5, 1, 7.5, 4);
    doc.addImage(sentimentImg2, "PNG", 0.5, 5.5, 7.5, 4);
    doc.addPage();
    doc.setPage(currentPage + 2);
    doc.addImage(sentimentImg3, "PNG", 0.5, 1, 7.5, 4);
    doc.addImage(sentimentImg4, "PNG", 0.5, 5.5, 7.5, 4);
    doc.addPage();
    doc.setPage(currentPage + 3);
    doc.text(TEXT["amplification"][language], 4.25, 0.5, {
      align: titleStyle.align,
    });
    doc.addImage(comparisonImg, "PNG", 0.5, 1, 7.5, 4);

    doc.save("reporte.pdf");
  };

  return (
    <div className="surveys-page-container">
      {/* country select */}
      <data className="data-page-content">
        <div className="rp-menu">
          {tabs.map((i) => {
            return (
              <button
                key={i.key}
                className={
                  "rp-menu-item" +
                  (currentTab === i.key ? " rp-menu-selected" : "")
                }
                onClick={() => handleClick(i.key)}
              >
                <span>{TEXT["tabs"][i.title][language]}</span>
              </button>
            );
          })}
        </div>
        <Divider className="divider-full-screen" />
        {currentTab === "mig" ? (
          <div className="surveys-page-title">
            <PageTitleSection
              title={TEXT["title"][language]}
              descriptionParagraphs={TEXT["description"][language]}
              image="resources2.png"
              /* callToActionElement={
              <div className="data-page-report-button">
                <a
                  href="https://publications.iadb.org/es/mas-alla-de-las-fronteras-estigmas-y-desafios-en-la-integracion-de-las-mujeres-migrantes-en-america"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <BIDButton
                    text={miscTEXT["downloadLatestReport"][language]}
                    type={"light"}
                    size={"medium"}
                  />
                </a>
              </div>
            } */
            />
          </div>
        ) : (
          <div className="surveys-page-title">
            <PageTitleSection
              title={"Análisis de noticias sobre retorno"}
              descriptionParagraphs={TEXT["description"][language]}
              image="surveys.png"
              callToActionElement={
                <div className="data-page-report-button">
                  <a
                    href="https://publications.iadb.org/es/mas-alla-de-las-fronteras-estigmas-y-desafios-en-la-integracion-de-las-mujeres-migrantes-en-america"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <BIDButton
                      text={miscTEXT["downloadLatestReport"][language]}
                      type={"light"}
                      size={"medium"}
                    />
                  </a>
                </div>
              }
            />
          </div>
        )}
        {/* <Divider className="divider-full-screen" /> */}
        {currentTab === "mig" ? (
          <Migracion
            selectedCountry={selectedCountry}
            countryName={countryName}
            countries={countries}
            showSection={showSection}
            setMediaImg1={setMediaImg1}
            setMediaImg2={setMediaImg2}
            setDiscussionImg={setDiscussionImg}
            setDiscussionImg2={setDiscussionImg2}
            setDiscussionImg3={setDiscussionImg3}
            setDiscussionImg4={setDiscussionImg4}
            setDiscussionImg5={setDiscussionImg5}
            setDiscussionImg6={setDiscussionImg6}
            setSentimentImg={setSentimentImg}
            setSentimentImg2={setSentimentImg2}
            setSentimentImg3={setSentimentImg3}
            setSentimentImg4={setSentimentImg4}
            setComparisonImg={setComparisonImg}
            COUNTRY_OPTIONS={COUNTRY_OPTIONS}
            handleSelectChange={handleSelectChange}
            mediosOnClick={mediosOnClick}
            sentimentOnClick={sentimentOnClick}
            comparisonOnClick={comparisonOnClick}
            discussionOnClick={discussionOnClick}
            isComparisonSelected={isComparisonSelected}
            isDiscussionSelected={isDiscussionSelected}
            isGenderSelected={isGenderSelected}
            isMediosSelected={isMediosSelected}
            isSentimentSelected={isSentimentSelected}
            language={language}
            handleDownloadReport={handleDownloadReport}
          />
        ) : (
          <Retorno
            selectedCountry={COUNTRY_OPTIONS_RET[0].code}
            countryName={COUNTRY_OPTIONS_RET[0].country_text}
            countries={countriesRet}
            showSection={showSection}
            setMediaImg1={setMediaImg1}
            setMediaImg2={setMediaImg2}
            setDiscussionImg={setDiscussionImg}
            setDiscussionImg2={setDiscussionImg2}
            setDiscussionImg3={setDiscussionImg3}
            setDiscussionImg4={setDiscussionImg4}
            setDiscussionImg5={setDiscussionImg5}
            setDiscussionImg6={setDiscussionImg6}
            setSentimentImg={setSentimentImg}
            setSentimentImg2={setSentimentImg2}
            setSentimentImg3={setSentimentImg3}
            setSentimentImg4={setSentimentImg4}
            setComparisonImg={setComparisonImg}
            COUNTRY_OPTIONS={COUNTRY_OPTIONS_RET}
            handleSelectChange={handleSelectChange}
            mediosOnClick={mediosOnClick}
            sentimentOnClick={sentimentOnClick}
            comparisonOnClick={comparisonOnClick}
            discussionOnClick={discussionOnClick}
            isComparisonSelected={isComparisonSelected}
            isDiscussionSelected={isDiscussionSelected}
            isGenderSelected={isGenderSelected}
            isMediosSelected={isMediosSelected}
            isSentimentSelected={isSentimentSelected}
            language={language}
            handleDownloadReport={handleDownloadReport}
          />
        )}
      </data>
    </div>
  );
}
